import React, { useState } from 'react';
import AuthenticatedComponent from './AuthenticatedComponent';
import NewsService from '../services/NewsService.js';
import ReactQuill from 'react-quill';
import { useNavigate } from 'react-router-dom';

function NewsEditorComponent() {
  const navigate = useNavigate();
  const [letter, setLetter] = useState('');

  const backClick = () => {
    navigate('/');
  };

  const sendAdmin = (e) => {
    e.preventDefault();
    NewsService.adminNewsPost({
      content: letter
    });
    NewsService.adminNewsGet();
    navigate('/hjem');
  };

  const sendPublic = (e) => {
    e.preventDefault();
    NewsService.publicNewsPost({
      content: letter
    });
    NewsService.publicNewsGet();
    navigate('/hjem');
  };

  const sendBoth = (e) => {
    e.preventDefault();
    NewsService.adminNewsPost({
      content: letter
    });
    NewsService.adminNewsGet();
    NewsService.publicNewsPost({
      content: letter
    });
    NewsService.publicNewsGet();
    navigate('/hjem');
  };

  const onTextChange = (value) => {
    setLetter(value);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div id="emailEdit">
                <ReactQuill theme="snow" value={letter} onChange={onTextChange} />
                <button className="btn btn-primary" onClick={backClick}>Afbryd</button>
                <button className="btn btn-primary ml-2" onClick={sendPublic}>Publicer offentligt</button>
                <button className="btn btn-primary ml-2" onClick={sendAdmin}>Publicer til admins</button>
                <button className="btn btn-primary ml-2" onClick={sendBoth}>Publicer til begge</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AuthenticatedComponent(NewsEditorComponent);